import './connected-stores.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import FontHeading4 from "../../../../components/fonts/font-heading4/font-heading4";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import {FONT_VARIANT} from "../../../../components/fonts/font-props";
import ParentChildStore from "../../stores/parent-child-store";
import {Toggle} from "../../../../components/inputs/toggle/toggle";
import {Note, NOTE_TYPE} from "../../../../components/note/note";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import ListLayout from "../../../../components/layouts/list-layout/list-layout";

interface IConnectedStore {
    store: ParentChildStore;
}

const ConnectedStores: React.FC<IConnectedStore> = observer(({store}) => {

    return (
    <ListLayout>
        <FontHeading4 variant={FONT_VARIANT.BOLD}>Connected Stores</FontHeading4>
        <div className="connected-children">
            {store.getChildren()?.map(connectedChild => (
                <div className="connected-child" key={connectedChild.id}>
                    <FontBody1>{connectedChild.name}</FontBody1>
                    <Toggle
                        label={''}
                        disabled={
                            store.selectedUserIsChild &&
                            store.selectedUserId !== connectedChild.id
                        }
                        checked={!store.isChildOnRemove(connectedChild.id)}
                        onChange={v => {
                            if (v) {
                                store.rollbackChildRemove(connectedChild.id)
                            } else {
                                store.removeChild(connectedChild.id)
                            }
                        }}
                    />
                </div>
            ))
            }
        </div>
        {store.childrenToRemove.length > 0 &&
            <Note type={NOTE_TYPE.ERROR} body={
                <>
                    <FontBody2>By saving this action, stores will remove it from {store.getParent()?.name} requiring
                        a new plan to be accepted for the disconnected stores.</FontBody2>
                    <br/>
                    <FontBody2>Automations will be paused, however customers can still submit return
                        requests.</FontBody2>
                </>
            }/>
        }
    </ListLayout>
)});

export default ConnectedStores;